<app-table
  [cols]="cols"
  [elements]="elements"
  [lazy]="false"
  [modelName]="modelName"
  [showHeader]="showHeader"
  [showTitle]="showTitle"
  [exportPdf]="exportPdf"
  [exportExcel]="exportExcel"
  [addButton]="addButton"
  [dropdownFilters]="dropdownFilters"
  [actionButtons]="actionButtons"
  *ngIf="cols && elements"
/>
